import React from 'react'
import * as styles from './content.module.css'


export const Excerpt = ({ excerpt }) => {
  return (
    <div className={styles.excerpt}>
      {excerpt}
    </div>
  )
}